import { PureComponent } from 'react'
import clx from 'classnames'
import styles from './ProposalStatusBar.css'
import { FormRow, HyperLink, When } from '../../../Common/Form'
import MultiLineText from '../../../Proposal/Common/ReadOnlyComponents/MultiLineText/MultiLineText'
import Tip from '../Tip'
import { Modal, Icon, ProposalBlock } from '@vzmi/shp_shared_compo'
import {
  PROPOSAL_REVIEW_STATUS,
  PROPOSAL_REVIEW_STATUS_MAP,
  PROPOSAL_EXECUTE_STATUS,
  PROPOSAL_EXECUTE_STATUS_MAP,
  PROPOSAL_DECLINE_REASONS_MAP,
  PROPOSAL_DECLINE_REASON
} from '@vzmi/shp_shared_compo/constants/proposal'
import { scrollToElement, getDefaultTimezoneMoment } from '../../../../../lib/renderUtil'
import _ from 'lodash'
import {
  isNewListingProposal,
  isNewProductProposal,
  isUpdateListingProposal
} from '../../../../../lib/proposalHelper'
import { ConnectedListingLink } from '../../../Common/ListingLink/ListingLink'
import { getListingPreviewPage } from '../ProposalForm/Shared/util'
import { EMPTY_VALUE } from '../../../../constants/globalTypes'

const VerticalBar = () => (
  <span className={styles.verticalBar}>
    |
  </span>
)

export const CheckListingIdBtn = () => {
  const scrollToListingId = () => {
    scrollToElement(
      document.querySelector("[data-role='attribute-table']"),
      0
    )
  }

  return (
    <span
      className={styles.checkItemId}
      onClick={scrollToListingId}
    >
      查看商品編號
    </span>
  )
}

export const ExecuteTime = props => {
  const { executedTime, modifiedTs, hasBatch, batchProposalResult = {} } = props
  const {
    isLoading,
    batchProposal: {
      executeStatus,
      executeTs,
      revertStatus,
      revertTs,
      instantExecute
    } = {},
    batch
  } = batchProposalResult
  if (hasBatch) {
    const isRevert = batch.type === 'revert'
    const statusLabel = _.get(
      PROPOSAL_EXECUTE_STATUS_MAP,
      isRevert ? revertStatus : executeStatus,
      EMPTY_VALUE
    )
    const [
      batchExecutedTime,
      actualBatchExecutedTime
    ] = [
      isRevert ? revertTs : executeTs,
      modifiedTs
    ].map(ts => getDefaultTimezoneMoment(ts).format('YYYY/MM/DD HH:mm:ss'))
    const instantExecuteStatus = instantExecute
      ? ''
      : `／預約執行時間：${batchExecutedTime}`
    const finishedStatus = (executeStatus === PROPOSAL_EXECUTE_STATUS.FINISHED)
      ? `／實際執行時間：${actualBatchExecutedTime}`
      : ''
    return (
      <Tip
        className={styles.statusTitle}
        type='info'
      >
        {isLoading && EMPTY_VALUE}
        {!isLoading && `${statusLabel}${instantExecuteStatus}${finishedStatus}`}
      </Tip>
    )
  }

  return (
    <Tip
      className={styles.statusTitle}
      type='info'
    >
      {`執行時間：${executedTime}`}
    </Tip>
  )
}

const StatusTitle = props => {
  const { title } = props
  return (
    <Tip
      className={styles.statusTitle}
      type='info'
    >
      {title}
    </Tip>
  )
}

export const ExecuteStatusTitle = props => {
  const { title } = props
  return (
    <div className={styles.contentWithExtraPadding}>
      <StatusTitle title={title} />
    </div>
  )
}

export const ExecuteStatusIcon = props => {
  const { executeStatus } = props
  switch (executeStatus) {
    case PROPOSAL_EXECUTE_STATUS.FINISHED: {
      return (
        <Icon
          name='ec-check'
          size={20}
        />
      )
    }
    case PROPOSAL_EXECUTE_STATUS.FAILED:
    case PROPOSAL_EXECUTE_STATUS.CANCELED: {
      return (
        <Icon
          name='decline'
          size={20}
        />
      )
    }
    default:
      return null
  }
}

export const ExecuteStatus = props => {
  const {
    proposalType,
    executeStatus,
    executeResult,
    listing,
    proposalId,
    executedTs,
    modifiedTs,
    hasBatch,
    batchProposalResult
  } = props

  const executeStatusLabel = PROPOSAL_EXECUTE_STATUS_MAP[executeStatus]
  const isNewListing = isNewListingProposal(proposalType)
  const isUpdateListing = isUpdateListingProposal(proposalType)
  const isUpdatingListing = isUpdateListingProposal(proposalType)
  const hasExecuteStatusFinished = executeStatus === PROPOSAL_EXECUTE_STATUS.FINISHED
  const isExecuteStatusFailed = executeStatus === PROPOSAL_EXECUTE_STATUS.FAILED
  const isExecuteStatusIdle = executeStatus === PROPOSAL_EXECUTE_STATUS.IDLE
  const isPreviewLinkEnabled = isNewListing && isExecuteStatusIdle
  const { id, swCode, isListingNotFound } = listing || {}
  const { uri: listingPreviewUri, target: listingPreviewTarget } = getListingPreviewPage(proposalId)

  const executedTime = executedTs ? getDefaultTimezoneMoment(executedTs).format('YYYY/MM/DD HH:mm:ss') : null
  return (
    <div className={styles.contentWithExtraPadding}>

      <span className={styles.executeStatus}>
        <ExecuteStatusIcon executeStatus={executeStatus} />
        <span data-role='execute-status-label-text'>
          {executeStatusLabel}
        </span>
        <When
          value={isPreviewLinkEnabled}
          isTrue
        >
          <a
            className={styles.listingPreviewLink}
            href={listingPreviewUri}
            target={listingPreviewTarget}
            rel='noopener noreferrer'
          >
            賣場預覽
          </a>
        </When>
        <When
          value={hasExecuteStatusFinished}
          isTrue
        >
          <When
            value={isNewListing || isUpdateListing}
            isTrue
          >
            <>
              ，賣場編號-
              <ConnectedListingLink
                targetListingId={id}
                swCode={swCode}
              >
                {id}
              </ConnectedListingLink>
              <When
                value={isListingNotFound}
                isTrue
              >
                <span className={styles.listingNotFound}>賣場不存在或已過刪除期限，無法正常顯示</span>
              </When>
            </>
          </When>
          <When
            value={!isUpdatingListing}
            isTrue
          >
            <VerticalBar />
            <CheckListingIdBtn />
          </When>
          <ExecuteTime
            executedTime={executedTime}
            modifiedTs={modifiedTs}
            hasBatch={hasBatch}
            batchProposalResult={batchProposalResult}
          />
        </When>
        <When
          value={isExecuteStatusFailed && !_.isEmpty(executeResult)}
          isTrue
        >
          <small data-role='execute-result-desc-text'>
            {` (${executeResult})`}
          </small>
        </When>
      </span>
    </div>
  )
}

const getBadword = (declineDetail) => {
  if (!declineDetail) {
    return ''
  }

  return declineDetail.replace('內容含有不合法文字: ', '')
}

/** 提案單狀態, 賣場/商品執行狀態列 */
class ProposalStatusBar extends PureComponent {
  constructor (props) {
    super(props)
    this.state = {
      declineModalVisible: false
    }
  }

  handleClickCheckDeclineReason = () => {
    const { declineModalVisible } = this.state
    this.setState(() => ({
      declineModalVisible: !declineModalVisible
    }))
  }

  handleCloseDeclineModal = () => {
    this.setState(() => ({
      declineModalVisible: false
    }))
  }

  renderDeclineModal = () => {
    const { declineModalVisible } = this.state
    const {
      declineReason = [],
      declineDetail = null,
      suggestion = null
    } = this.props
    const declineReasonSet = new Set(declineReason)
    return (
      <Modal
        visible={declineModalVisible}
        closable
        disableFooter
        title='審核不通過原因'
        onClose={this.handleCloseDeclineModal}
        className={styles.declineReasonModal}
      >
        <ul
          data-role='decline-reasons'
          className={styles.declineReasons}
        >
          {
            _.reduce(PROPOSAL_DECLINE_REASONS_MAP, (arr, label, key) => {
              const hasDeclineReason = declineReasonSet.has(key)
              hasDeclineReason && arr.push((<li>
                {label}
                {
                  key === PROPOSAL_DECLINE_REASON.OTHER && (
                    <span>
                      {`: ${declineDetail}`}
                    </span>
                  )
                }
              </li>))
              return arr
            }, [])
          }
        </ul>
        {suggestion && (
          <section data-role='review-suggestion'>
            <h4 className={styles.declineDetailTitle}>改善或建議</h4>
            <MultiLineText
              content={suggestion}
              className={styles.declineDetail}
            />
          </section>
        )}
      </Modal>
    )
  }

  getReviewStatusLabel = (isBadWord) => {
    const { reviewStatus, declineDetail = null } = this.props
    const badWord = getBadword(declineDetail)
    const label = PROPOSAL_REVIEW_STATUS_MAP[reviewStatus]
    return (
      <span className={styles.reviewStatusLabel}>
        <span data-role='review-status-label-text'>
          {label}
        </span>
        {reviewStatus === PROPOSAL_REVIEW_STATUS.DECLINED && (
          <>
            {!isBadWord && (
              <>
                <span
                  data-role='check-decline-reason'
                  className={styles.checkDeclineReason}
                  onClick={this.handleClickCheckDeclineReason}
                >
                  查看原因
                </span>
                {this.renderDeclineModal()}
              </>
            )}
            {isBadWord && (
              <>
                {'，內容含有不合法文字：'}
                <HyperLink
                  target='_blank'
                  href={`/keyword/query?displayName=${encodeURIComponent(badWord)}`}
                >
                  {badWord}
                </HyperLink>
              </>
            )}
          </>

        )}
      </span>
    )
  }

  getExecuteStatusTitle = () => {
    const { proposalType } = this.props
    const prefix = isNewProductProposal(proposalType)
      ? ''
      : '賣場/'
    return `${prefix}商品執行狀態`
  }

  render () {
    const {
      proposalType,
      executeStatus,
      executeResult,
      buyGdSaleUrl,
      listing,
      proposalId,
      executedTs,
      modifiedTs,
      hasBatch,
      batchProposalResult,
      declineReason = []
    } = this.props
    const isBadWord = PROPOSAL_DECLINE_REASON.BADWORD in _.keyBy(declineReason)

    return (
      <ProposalBlock
        data-role='proposal-status-bar'
        className={styles.ProposalStatusBar}
      >
        <FormRow
          key='statusTitle'
          label={<StatusTitle title='提案單狀態' />}
          className={clx({ [styles.badWord]: isBadWord })}
        >
          <ExecuteStatusTitle title={this.getExecuteStatusTitle()} />
        </FormRow>
        <FormRow
          key='statusResult'
          label={this.getReviewStatusLabel(isBadWord)}
          className={clx(styles.resetMargin, { [styles.badWord]: isBadWord })}
        >
          <ExecuteStatus
            proposalType={proposalType}
            executeStatus={executeStatus}
            executeResult={executeResult}
            buyGdSaleUrl={buyGdSaleUrl}
            listing={listing}
            proposalId={proposalId}
            executedTs={executedTs}
            modifiedTs={modifiedTs}
            hasBatch={hasBatch}
            batchProposalResult={batchProposalResult}
          />
        </FormRow>
      </ProposalBlock>
    )
  }
}

export default ProposalStatusBar
